import {
  ManagedEntitiesGroupedByProviders,
  ManagedEntitiesGroupedByStacks,
  ManagedEntitiesGroupedByTypes,
  ManagedEntity,
} from "types/generated";
import { UseIacManagementResourcesFetchProps } from "views/Account/IacManagement/useIacManagementResources";

export type IacTableGroupMeta = {
  isOpen: boolean;
  hasMore: boolean;
  endCursor?: string;
};

export enum IacTableServiceRowType {
  LoadMoreResources = "load-more-resources",
  LoadMoreGroups = "load-more-groups",
}

type IacTableServiceRow = {
  id: string;
  serviceType: IacTableServiceRowType;
  groupId: string;
};

export type IacManagementGroup =
  | ManagedEntitiesGroupedByStacks
  | ManagedEntitiesGroupedByProviders
  | ManagedEntitiesGroupedByTypes;
export type IacTableRow = IacManagementGroup | ManagedEntity | IacTableServiceRow;

export type IacTableDataSlice = {
  groups: IacManagementGroup[];
  groupsLoading: boolean;
  setGroupsLoading: (groupsLoading: boolean) => void;
  setGroups: (groups: IacManagementGroup[]) => void;
  resources: Record<ManagedEntity["id"], ManagedEntity>;
  resourcesIdsPerGroup: Record<string, ManagedEntity["id"][]>;
  groupsMeta: Record<string, IacTableGroupMeta>;
  toggleGroupMeta: (groupId: string) => void;
  openGroup: (groupId: string) => void;
  updateGroupMeta: (groupId: string, meta: Partial<IacTableGroupMeta>) => void;
  loadResources: (
    queryProps: Pick<
      UseIacManagementResourcesFetchProps,
      "groupBy" | "groupId" | "parentStackId" | "rowsPerPage"
    >,
    asyncQuery: (props: UseIacManagementResourcesFetchProps) => Promise<{
      data: ManagedEntity[];
      hasMore: boolean;
      endCursor: string | undefined;
    }>
  ) => void;
  flushTable: () => void;
};
